import {Component} from 'substance'

/**
 * @typedef UIDropdown.props
 * @property {Array.<{label: string, value: *}>}   options            An array of Objects with "label" and "value" properties
 * @property {string} [header=undefined]  Optional header property, renders an `h2`-element above the dropdown
 * @property {boolean} [disabled=false]    Set to true to disable selection of the dropdown
 * @property {function(value)} onChangeList        Callback function when selected option changes. Selected item's value as parameter
 * @property {function} isSelected          Callback which should return true for the currently selected option, runs for each item when rendered and gets all options and current option as parameters.
 */

/**
 * Simple Drop down component, which renders a `select`-element containing `option`-elements.
 *
 * @name UIDropdown
 * @class
 *
 * @example
 * import {UIDropdown} from 'writer'
 *
 * render($$) {
 *   const el = $$('div')
 *   return el.append(
 *      $$(UIDropdown, {
 *          options: [ {label: "one", value: 1}, {label: "two", value: 2} ],
 *          header: "One or two",
 *          onChangeList: (value) => { this.extendState({ selectedValue: value }) },
 *          isSelected: (options, option) => { return option.value === this.state.selectedValue }
 *      })
 *   )
 * }
 *
 * @param {UIDropdown.props} props
 * @property {UIDropdown.props} props
 */
class DropdownComponent extends Component {

    render($$) {
        const options = this.props.options
        const listGroup = $$('div').addClass('select-group-gmlist')

        if (this.props.header) {
            listGroup.append($$('h2').append(this.props.header))
        }

        const selectList = $$('select').addClass('form-control')
            .on('change', (e) => {
                let selectedIndex = e.currentTarget.selectedIndex
                if (this.props.onChangeList) {
                    this.props.onChangeList(options[selectedIndex].value)
                }
            })

        if (this.disabled) {
            selectList.attr('disabled', true)
        }

        const optionElements = options.map(data => {
            const option = $$('option')
                .attr({
                    label: data.label,
                    value: data.value
                })

            if (this.props.isSelected && this.props.isSelected(options, data)) {
                option.attr('selected', true)
            }

            return option
        })

        return listGroup.append(
            selectList.append(optionElements)
        )
    }

    /**
     * @returns {boolean}
     * @private
     */
    get disabled() {
        return this.props.disabled === true
    }

}

export {DropdownComponent}
